import { render, staticRenderFns } from "./DeviceSettingDialog2.vue?vue&type=template&id=1b3e3edc&scoped=true"
import script from "./DeviceSettingDialog2.vue?vue&type=script&lang=js"
export * from "./DeviceSettingDialog2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3e3edc",
  null
  
)

export default component.exports